import { isChannel } from "@website/utils/channel/helpers";
import { deepCompare } from "@website/utils/deep-compare";
import { FooterComponent } from "@website/widget/footer/footer.component";
import { FooterPropertiesType } from "@website/widget/footer/footer.types";
import { FC, memo } from "react";

export const Component: FC<FooterPropertiesType> = (properties) => {
  if (isChannel(["android", "jek", "ads", "SNAPP_AD", "ads"])) {
    return <div className="h-12" />;
  }

  return <FooterComponent {...properties} />;
};
export const Footer = memo(Component, deepCompare);
